/** Client-side auth field checks — server still enforces the same rules. */

export const PASSWORD_MIN_LEN = 8;
export const PASSWORD_MISMATCH_MESSAGE = 'Password and Confirm Password do not match. Please try again.';

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function validatePassword(password) {
  const value = password == null ? '' : String(password);
  if (!value) return 'Password is required';
  if (value.length < PASSWORD_MIN_LEN) return `Password must be at least ${PASSWORD_MIN_LEN} characters`;
  if (value.length > 72) return 'Password is too long';
  if (!/[A-Za-z]/.test(value) || !/[0-9]/.test(value)) return 'Password must include a letter and a number';
  return '';
}

/**
 * Checks a new password and its confirmation. Returns errors keyed by field
 * (`password`, `confirmPassword`) so each message can be shown next to its input;
 * an empty object means valid. A mismatch is reported once, on `confirmPassword`.
 */
export function validatePasswordPair(password, confirmPassword) {
  const errors = {};
  const policy = validatePassword(password);
  if (policy) errors.password = policy;
  if (!confirmPassword) {
    errors.confirmPassword = 'Confirm password is required';
  } else if (password && confirmPassword !== password) {
    errors.confirmPassword = PASSWORD_MISMATCH_MESSAGE;
  }
  return errors;
}

/**
 * Field-keyed errors (`email`, `password`) for the sign-in form. Sign-in is by registered email
 * address only — a username or first name is rejected here, the same as the API does.
 */
export function validateSignInFields({ email, password }) {
  const errors = {};
  if (!String(email || '').trim()) errors.email = 'Email is required';
  else if (!isValidEmail(email)) errors.email = 'Enter a valid email address';
  if (!password) errors.password = 'Password is required';
  return errors;
}

/** Field-keyed errors (`firstName`, `email`, `password`, `confirmPassword`) for the register form. */
export function validateRegisterFields({ firstName, email, password, confirmPassword }) {
  const errors = {};
  if (!String(firstName || '').trim()) errors.firstName = 'First name is required';
  if (!String(email || '').trim()) errors.email = 'Email is required';
  else if (!isValidEmail(email)) errors.email = 'Enter a valid email address';
  return { ...errors, ...validatePasswordPair(password, confirmPassword) };
}
